module.exports = __webpack_public_path__ + "static/images/components/ButtonTiny/images/secondary-borders.6b8b351e.png";


//////////////////
// WEBPACK FOOTER
// ./components/ButtonTiny/images/secondary-borders.png
// module id = 2584
// module chunks = 11